<template>
  <div class="row" style="margin-top: 100px">
    <div class="col-lg-3"></div>
    <div class=" card col-lg-5">
      <form>
        <div class="col-md-12 col-lg-12">
          <label class="form-label">انتخاب دسته بندی</label>
          <select v-model="cat_id" class="form-select text-center">
            <option value="" v-html="text"></option>
            <option v-for="lists in listCat" :value="lists.id">{{ lists.title }}</option>
          </select>
        </div>
        <div class="col-md-12 col-lg-12">
          <label class="form-label">اپلود فایل اکسل</label>
          <input type="file" class="form-control" id="files">
        </div>
        <div class="col-lg-12" style="padding: 10px 20px">
          <btn_loading v-if="loading"></btn_loading>
          <button type="button" v-else @click="upload()" class="btn btn-danger form-control">ارسال فایل</button>
        </div>
      </form>
    </div>
    <div class="col-lg-2"></div>
  </div>
</template>

<script>

import config from "../../../../../config/config.json";
import {useToast} from "vue-toastification";
import Btn_loading from "@/common/components/btn_loading.vue";
import axios from "axios";

export default {
  name: "UploadFile",
  components: {Btn_loading},
  data() {
    return {
      loading: false,
      listCat: {},
      cat_id: "",
      text: "لطفا دسته بندی را انتخاب کنید"
    }
  },
  created() {
    this.getCat();
  },
  methods: {
    getCat: function () {
      let self = this;
      axios.get('/categories/lists')
          .then(function (res) {
            self.listCat = res.data.data;
          })
          .catch(function (errors) {
            console.log(errors);
          });
    },
    upload: function () {
      let self = this;
      const toast = useToast();
      self.loading = true;
      let formData = new FormData();
      formData.append('file', document.getElementById('files').files[0]);
      formData.append('cat_id', self.cat_id);
      self.axios.post(`${config.BASE_URL}/Experiments`,
          formData,
          {
            headers: {
              Accept: "application/json",
              'Content-Type': 'multipart/form-data',
              responseType: "json",
            }
          }
      ).then(function (res) {
        self.loading = false;
        if (res.data.status === 'true') {
          toast.success(res.data.messages);
        }
      })
          .catch(function (error) {
            self.loading = false;
            if (error?.response?.status === 422) {
              Object.values(error.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (error?.response?.status === 404) {
              toast.error(error.response.data.messages);
            }
            toast.error("فایل اکسل ارسال شده ساختار نامناسبی دارد ");

          });
    }
  }
}
</script>

<style scoped>

</style>